import "../../styles/screens/services.scss";
import handIcon from "../../assets/images/Icons/handIcon.png";
import handImg from "../../assets/images/Images/handImg.png";
import AOS from "aos";
import de from "../../assets/texts/de.json";
import sr from "../../assets/texts/sr.json";
import { useLanguage } from "../../i18n/LanguageContext";
import "aos/dist/aos.css";

const ServiceSecond = () => {
  AOS.init({ duration: 2000 });
  const { language } = useLanguage();
  const t = language === "sr" ? sr.servicePages.second : de.servicePages.second;
  return (
    <div className="service-second">
      <div className="service-title" data-aos="fade-down">
        <h1 className="title">{t.title}</h1>
        <img className="hands" src={handIcon} alt="Handshake"></img>
      </div>
      <div className="divider"></div>
      <div className="content">
        <ul className="points">
          <li
            className="subtitle-first"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="100"
          >
            {t.intro}
          </li>
          <li
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="400"
          >
            {t.points[0]}
          </li>
          <li
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="700"
          >
            {t.points[1]}
          </li>
          <li
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="1000"
          >
            {t.points[2]}
          </li>
          <li
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="1300"
          >
            {t.points[3]}
          </li>
          <li
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="1600"
          >
            {t.points[4]}
          </li>
        </ul>
        <div className="image-container">
          <img src={handImg} alt="Revenue Management" />
        </div>
      </div>
      <div className="subtitle-second">
        <p>
          {t.outro}
        </p>
      </div>
    </div>
  );
};

export default ServiceSecond;
